import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the resetPassword state domain
 */

const selectResetPasswordDomain = state => state.resetPassword || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by ResetPassword
 */

const selectResetPasswordData = () =>
  createSelector(
    selectResetPasswordDomain,
    substate => substate.resetPasswordData,
  );

const selectResetPasswordList = () =>
  createSelector(
    selectResetPasswordDomain,
    substate => substate.resetPasswordList,
  );

const selectResetPasswordLoading = () =>
  createSelector(
    selectResetPasswordDomain,
    substate => substate.loading,
  );

const selectResetPasswordError = () =>
  createSelector(
    selectResetPasswordDomain,
    substate => substate.error,
  );

const selectResetPasswordDeleteSuccessful = () =>
  createSelector(
    selectResetPasswordDomain,
    substate => substate.deleteSuccessful,
  );

export {
  selectResetPasswordDomain,
  selectResetPasswordLoading,
  selectResetPasswordError,
  selectResetPasswordDeleteSuccessful,
  selectResetPasswordData,
  selectResetPasswordList,
};
